import { Platform } from '../../BuildConfig';
import { UrlParams } from '../UrlParams';

export function detectPlatform(): Platform {
	const okApiServer = UrlParams.get('api_server');
	if (okApiServer && okApiServer.indexOf('ok') !== -1) {
		return 'ok';
	}

	const vkApiUrl = UrlParams.get('api_url');
	if (vkApiUrl && (vkApiUrl.includes('vk.com') || vkApiUrl.includes('vk.ru'))) {
		return 'vk';
	}

	// это FB билд, запущенный через localhost, используется разработчиками
	if (location.host === 'localhost:8080' && UrlParams.has('source')) {
		return 'fbInstant';
	}

	// это FB билд на dev/stable/master/prod окружениях
	if (location.host.endsWith('apps.fbsbx.com')) {
		return 'fbInstant';
	}

	if (location.host.includes('ya-global') || location.hash.includes('yandex') || location.hash.includes('playhop')) {
		return 'ya';
	}

	// TODO crazy-games - better way to detect Crazy Games platform
	const source = UrlParams.get('source');
	if (source === 'crazy-games') {
		return 'cg';
	}

	return 'none';
}
